import { createPendingQueueStore } from '../lib/pendingQueue.js';
import type { CompleteLessonPayload } from './hooks.js';

/**
 * Offline queue for lesson completions that haven't been confirmed by
 * the server yet. Entries survive reloads via localStorage. When the
 * app comes back online (or focuses), the queue is flushed.
 *
 * Unlike the flashcard/practice queues this one is enqueue-on-error only
 * (`complete_lesson` is not replay-idempotent — see the MAX_ATTEMPTS note
 * in PendingQueueFlusher).
 */

export interface PendingCompletion {
  /** Unique id scoped to the client — we never send it to the server. */
  id: string;
  userId: string;
  payload: CompleteLessonPayload;
  queuedAt: number;
  /** Incremented on every failed retry; bail at MAX_ATTEMPTS. */
  attempts?: number;
}

export const usePendingQueueStore = createPendingQueueStore<{ items: PendingCompletion }>({
  storageKey: 'fluent.pending-completions.v1',
  collections: { items: (i) => i.id },
});
